module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-17.8d47535c.jpg";